module.exports = __webpack_public_path__ + "static/img/logo1.4a8ea551.png";